import React, { useState } from "react";
import {
  call,
  Logo,
  password,
  reminder,
  reminder_1,
  pass_un,
  person,
} from "../../assets/img";
import { useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { MaskIcon } from "../../Component/MaskIcon";


const Register = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showOtp, setShowOtp] = useState(false);
  const [countryCode, setCountryCode] = useState("in");
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({ password: "", mobile: "" });

  const handleSendOtp = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!validatePhone(mobile)) {
      newErrors.mobile = "Enter a valid phone number";
    }
    setShowOtp(true);
  };

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };


  const handlePhoneChange = (value, data) => {
    setMobile(value.replace(/[-\s]/g, ""));
    if (data?.country?.dialCode) {
      setCountryCode(`+${data?.country?.dialCode}`);
    }
  };

  return (
    <div className="container_overall container_header">
      <div className="row register-wrapper">
        <h2 className="mt-4 text-center f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 primary">
          Register
        </h2>
        <form className="login-form  my-3">
          <div className="form-group text-start">
            <label className="form-label f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Name
            </label>
            <div className="login-input mt-2">
              <input type="tel" placeholder="Enter mobile number" required className="placholdercolorchanges2" />
              <MaskIcon src={person} alt="call" />
            </div>
          </div>
          <div className="form-group text-start my-3">
            <label className="form-label f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Mobile Number
            </label>
            <div
              className="login-input mt-1"
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "5px 10px",
                height: 50,
                background: "#F0EDE6",
              }}
            >
              <PhoneInput
                defaultCountry="in"
                value={mobile}
                onChange={(val, data) => handlePhoneChange(val, data)}
                showFlags={false}
                forceDialCode={true}
                style={{
                  width: "100%",
                  border: "none",
                  outline: "none",
                  fontSize: 16,
                }}
                inputClassName="phone-input-no-border"
                disableFormatting
              />
              <style>{`
                                             .phone-input-no-border {
                                               border: none !important;
                                               outline: none !important;
                                               box-shadow: none !important;
                                               background-color: #F0EDE6 !important;
                                             }
                                             .react-international-phone__country-dropdown {
                                               border: none !important;
                                               box-shadow: none !important;
                                               background-color: #F0EDE6 !important;
                                             }
                                             .react-international-phone__phone-input {
                                               border: none !important;
                                               background-color: #F0EDE6 !important;
                                             }
                                             .react-international-phone-input-container .react-international-phone-country-selector-button {
                                               border: none !important;
                                               background-color: #F0EDE6 !important;
                                             }
                                           `}</style>
              <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative' }} />
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>
          <div className="form-group text-start my-3">
            <label className="form-label f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Referral Code
            </label>
            <div className="login-input mt-2">
              <input type="tel" placeholder="DFHUTEWX" required className="placholdercolorchanges2" />
            </div>
          </div>
          <button
            className="login-btn f4 mt-4 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 "
            onClick={handleSendOtp}
          >
            Send OTP
          </button>
          {showOtp && (
            <>
              {" "}
              <p className=" my-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
                Enter the OTP
              </p>
              <div className="otp-container">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="number"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, index)}
                    className="otp-input placholdercolorchanges2"
                  />
                ))}
              </div>
              <p className="mt-2 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18  primary text-end">
                Resend OTP in 60s
              </p>{" "}
              <button className="login-btn f4 mt-4 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 ">
                Continue
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default Register;
